import React, { Component } from 'react';
import './cigerate.css';
import Navbar from '../layouts/navbar';
import { HashLink } from 'react-router-hash-link';


class Opioids extends Component {
    componentDidMount(){
        window.scrollTo(0,0);
    }
    render() {
        return (
            <div>
                <Navbar head="Opioids" />
                <div className="container" style={{marginTop:"60px"}}>
                    <HashLink to='/faq#opioids'>
                        <button id="myBtn" title="FAQ">
                            <i class="fas fa-info-circle faqicon"></i>
                            <p>  FAQ</p>
                        </button>
                    </HashLink>

                    <div className="row justify-content-center">
                        <div className="col-12 text-center ">
                            <img className="img-fluid" src="/assests/images/educationOpioids.png" alt="Opioids">
                            </img>

                        </div>
                    </div>

                    <div className="content">
                        <h2>Prescription Opioids</h2>
                        <p>Opioids are naturally found in opium poppy plant. Some prescription opioids are made from chemicals extracted directly from the plant, while some are synthetically manufactured by scientists in labs. Prescription opioids are <b>used as medicines</b> since they contain chemicals that <b>relax the body and relieve it from pain</b>.
                        </p>
                        <p>
                            Healthcare providers often prescribe opioids for this reason <b>to treat moderate to severe pain</b> (as is the case with cancer patients). However, there is a <b>high potential for misuse</b> since the drugs make one feel relaxed and “high”.
                        </p>

                        <p>Common slang for the drug include Oxys, Percs, and Vikes. Prescription opioids include drugs like <b>hydrocodone, oxycodone, morphine</b> (pain killer- often prescribed to cancer patients), <b>codeine (as cough syrup), fentanyl, tramadol.</b></p>

                        <p>Opium poppy and opium gum <b>can be legally produced in India</b>. The cultivation of opium plant for medical and scientific purposes is permitted and regulated by the Central Government under the NDPS Act. Licenses are issued to farmers for the cultivation, and Central Bureau of Narcotics ensures that conditions are followed.</p>

                        <p><b>Poppy straw</b> is the husk left after the opium is extracted from the pods. This also contains a very small morphine content and if used in sufficient quantities, poppy straw can give a high.
                        Possession, sale, and use of poppy straw is regulated by the State Governments. Farmers are expected to sell the poppy straw to licensed buyers. Any excess poppy straw should be ploughed back into the field. Poppy straw is one of the narcotic drugs under the NDPS Act, 1985. Hence, anyone possessing, selling, purchasing or using poppy straw without a license or authorization or in violation of any conditions of the license is liable to prosecution under the NDPS Act.
                        </p>
                        <p>
                        Prescription opioids are usually fine when taken for limited durations under the prescription of a doctor. However, people can <b>misuse these drugs by taking it in different doses</b> than prescribed, using someone else’s medication, or using it recreationally. Opioids <b>block pain signals</b> from the body to the brain, and <b>release large amounts of dopamine</b> throughout the body. This release can <b>reinforce drug-taking behaviour</b>, making the user repeat the experience.
                        </p>


                        <h4>
                            Short term effects include
                        </h4>
                        <ul>
                            <li>Drowsiness</li>
                            <li>Confusion</li>
                            <li>Nausea</li>
                            <li>Constipation</li>
                            <li>Euphoria</li>
                            <li>Slowed Breathing which can cause hypoxia (when little oxygen reaches the brain)</li>
                            

                        </ul>

                        <p><b>Long term effects</b> of prescription opioid use include <b>slowed metabolism, higher risk of HIV infection</b> (in case drug is crushed and mixed with water to inject), as well as <b>severe dependence and withdrawal</b>. Withdrawal symptoms can include- </p>
                        <ul>
                            <li>Irritability</li>
                            <li>    Restlessness</li>
                            <li>    Severe muscle and bone pain</li>
                            <li>    Sleep problems</li>
                            <li>    Diarrhea and vomiting</li>
                            <li>    Cold flashes with goosebumps (“cold turkey”)</li>
                            <li>    Uncontrollable leg movements</li>
                            <li>    Severe heroin cravings</li>
                            
                        </ul>

                       
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Opioids;